
/**
 * The injectionContainer is a lightweight method of dependency injection, which
 * we are using to avoid cyclic file dependencies, particularly those where we
 * widely depend on an interface but don't need to depend on particular
 * implementations.
 *
 * It is intended to be used in the following way:
 *
 * - Instantiate a container adjacent to where the interface is defined
 * - Define a script that populates the containers, stored adjacent to where the
 *     implementations are defined
 * - Import the population script when the app loads, from the top of
 *     `vizportal.ts` along with the other DI population scripts.
 */
export function injectionContainer<T>(thingName: string): { get: () => T, set: (t: T) => void } {
  let thing: T;

  function set(t: T): void {
    if (thing) {
      throw new Error(`Cannot overwrite ${thingName}; it has already been initialized.`);
    }
    thing = t;
  }

  function get(): T {
    if (!thing) {
      throw new Error(`Cannot access ${thingName}; it has not yet been initialized.`);
    }
    return thing;
  }

  return { get, set };
}
